import React from 'react';
import * as RadixSelect from '@radix-ui/react-select';
import classNames from 'classnames';

import styles from './SelectItem.module.scss';

export interface ISelectItemProps extends RadixSelect.SelectItemProps {
    size?: 'small' | 'regular';
}

export const SelectItem: React.FC<ISelectItemProps> = ({ children, className, size = 'regular', ...props }) => {
    return (
        <RadixSelect.Item
            className={classNames(
                styles.selectItem,
                {
                    [styles['selectItem-small']]: size === 'small',
                },
                className,
            )}
            {...props}
        >
            <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
        </RadixSelect.Item>
    );
};
